import { TextField } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { capitaliseText, isNotEmpty } from "../../../helpers/StringHelpers"
import { FormFieldProps } from "../../FormFieldProps/FormFieldProps"
import { disableFieldCheck } from "../../../services/validation/address-employment-form/disableFieldCheck"

const JobTitleField = (props: FormFieldProps<string>) => {
    const { t } = useTranslation(`signup`)
    const {
        defaultValue,
        handleChange,
        handleBlur,
        errorText,
        dependentField,
        isDisabled,
    } = props

    const [value, setValue] = useState(``)

    useEffect(() => {
        if (disableFieldCheck.has(dependentField ?? ``)) {
            setValue(``)
            return
        }
        if (defaultValue !== null && defaultValue !== undefined) {
            setValue(defaultValue)
        }
    }, [dependentField, defaultValue])

    const handleOnBlur = () => {
        if (handleBlur) {
            handleBlur(value)
        }
    }
    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setValue(capitaliseText(event.target.value))
        handleChange(capitaliseText(event.target.value))
    }

    const checkDisabled = () => {
        if (disableFieldCheck.has(dependentField ?? ``)) {
            return `none`
        }
        return `box`
    }

    return (
        <TextField
            fullWidth
            defaultValue={defaultValue}
            error={isNotEmpty(errorText ?? ``)}
            helperText={errorText ? t(errorText) : ``}
            id="job-title"
            label={t(`job_title`)}
            value={value}
            onChange={handleOnChange}
            sx={{ display: checkDisabled() }}
            onBlur={handleOnBlur}
            disabled={isDisabled}
        />
    )
}

export { JobTitleField }